import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import { Icon } from 'react-icons-kit';
import { ic_check_circle } from 'react-icons-kit/md/ic_check_circle';

import Container from 'common/src/components/UI/ContainerTwo';
import Text from 'common/src/components/Text';
import Heading from 'common/src/components/Heading';
import Image from 'common/src/components/Image';
import List from 'common/src/components/List';

import SectionWrapper, {
  Section,
  Content,
  Illustration,
  ListGroup,
} from './customerSupport.style';
import illustration from 'common/src/assets/image/agencyDigital/illustration.png';

const CustomerSupport = () => {
  const data = useStaticQuery(graphql`
    query {
      agencyDigitalJson {
        workHardList {
          id
          title
        }
      }
    }
  `);
  const list = data.agencyDigitalJson.workHardList;
  return (
    <SectionWrapper>
      <Container>
        <Section>
          <Illustration>
            <Image src={illustration} alt="Illustration" />
          </Illustration>
          <Content>
            <Heading as="h2" content="How do we do it? Get to know!" />
            <Text content="Customer support and complete visibility on the work during the complete course of engagement with us" />
            <ListGroup>
              {list.map((item) => (
                <List
                  className="list-item"
                  key={item.id}
                  text={item.title}
                  icon={
                    <Icon
                      icon={ic_check_circle}
                      size={18}
                      style={{ color: '#56BBD0' }}
                    />
                  }
                />
              ))}
            </ListGroup>
          </Content>
        </Section>
      </Container>
    </SectionWrapper>
  );
};

export default CustomerSupport;
